import { defaultTheme } from "@aircall/tractor";

export const theme = {
  ...defaultTheme,
  screens: {
    ...defaultTheme.screens,
    xxl: 1440,
  },
};
